export const kMaxUsersBeforeEnterprisePricing = 20
